import { useQuery } from "@tanstack/react-query"
import { useTRPC } from "utils/trpc"

export const useChainsList = ({ include_all_chains = false } = {}) => {
  const trpc = useTRPC()

  return useQuery(
    trpc.chains.getChains.queryOptions(
      {
        include_all_chains,
      },
      {
        // Store for 1 day
        staleTime: 1000 * 60 * 60 * 24,
      }
    )
  )
}
